// src/constants/characterLinks.ts
// キャラクター用リンクプラットフォーム定義

import React from 'react';

export type CharacterLinkPlatform = 'youtube' | 'twitch' | 'niconico' | 'twitter' | 'website' | 'other';

interface PlatformInfo {
  name: string;
  color: string;
  icon: (props: { className?: string; style?: React.CSSProperties }) => React.ReactElement;
}

// YouTube logo
const YouTubeIcon = ({ className, style }: { className?: string; style?: React.CSSProperties }) =>
  React.createElement('svg', { className, style, viewBox: '0 0 24 24', fill: 'currentColor' },
    React.createElement('path', { d: 'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z' })
  );

// Twitch logo
const TwitchIcon = ({ className, style }: { className?: string; style?: React.CSSProperties }) =>
  React.createElement('svg', { className, style, viewBox: '0 0 24 24', fill: 'currentColor' },
    React.createElement('path', { d: 'M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714z' })
  );

// Niconico logo
const NiconicoIcon = ({ className, style }: { className?: string; style?: React.CSSProperties }) =>
  React.createElement('svg', { className, style, viewBox: '0 0 24 24', fill: 'currentColor' },
    React.createElement('path', { d: 'M.4787 7.534v12.794c0 1.15.9325 2.083 2.083 2.083h18.877c1.15 0 2.083-.933 2.083-2.083V7.534c0-1.15-.933-2.083-2.083-2.083h-2.863L16.479 1.59a.8587.8587 0 0 0-1.213.0508l-2.46 2.705-2.46-2.705a.8587.8587 0 0 0-1.213-.0508L7.035 3.688 5.399 5.451H3.562c-1.15 0-2.083.933-2.083 2.083zm6.499 1.99l2.75 5.607h-1.537l-.503-1.089H5.652l-.544 1.089H3.628l2.749-5.607zm1.453 3.487l-.722-1.57-.79 1.57zm3.634-3.487h1.402v4.47h2.717v1.137h-4.12zm5.686 0h1.402v5.607h-1.402z' })
  );

// X (Twitter) logo
const XIcon = ({ className, style }: { className?: string; style?: React.CSSProperties }) =>
  React.createElement('svg', { className, style, viewBox: '0 0 24 24', fill: 'currentColor' },
    React.createElement('path', { d: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z' })
  );

// Globe/Website icon
const WebsiteIcon = ({ className, style }: { className?: string; style?: React.CSSProperties }) =>
  React.createElement('svg', { className, style, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    React.createElement('circle', { cx: '12', cy: '12', r: '10' }),
    React.createElement('line', { x1: '2', y1: '12', x2: '22', y2: '12' }),
    React.createElement('path', { d: 'M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z' })
  );

// Link icon (for other)
const OtherLinkIcon = ({ className, style }: { className?: string; style?: React.CSSProperties }) =>
  React.createElement('svg', { className, style, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    React.createElement('path', { d: 'M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71' }),
    React.createElement('path', { d: 'M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71' })
  );

export const CHARACTER_LINK_PLATFORMS: Record<CharacterLinkPlatform, PlatformInfo> = {
  youtube: { name: 'YouTube', color: '#FF0000', icon: YouTubeIcon },
  twitch: { name: 'Twitch', color: '#9146FF', icon: TwitchIcon },
  niconico: { name: 'ニコニコ動画', color: '#252525', icon: NiconicoIcon },
  twitter: { name: 'X (Twitter)', color: '#000000', icon: XIcon },
  website: { name: 'HP', color: '#4A90D9', icon: WebsiteIcon },
  other: { name: 'その他', color: '#666666', icon: OtherLinkIcon },
};

export const MAX_CHARACTER_LINKS = 6;
